import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { ClienteItemTipoComponent } from './cliente-item-tipo.component';
import { ClienteItemTipoMapPipe } from './pipes';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ClienteItemTipoComponent,

        // Pipes
        ClienteItemTipoMapPipe
    ],
    exports: [
        ClienteItemTipoComponent,

        // Pipes
        ClienteItemTipoMapPipe
    ],
    providers: [
        // Pipes
        ClienteItemTipoMapPipe
    ]
})
export class ClienteItemTipoModule { }
